import { motion } from "framer-motion";
import { Label, MaskedLines } from "./Reveal";

export default function PageHero({ label, titleLines, description, image, imageAlt }) {
  return (
    <section className="relative min-h-[75vh] flex items-center overflow-hidden" data-testid="page-hero">
      <div className="absolute inset-0 z-0">
        <img src={image} alt={imageAlt} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/20" />
      </div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 w-full pt-32 pb-16">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}>
          <Label>{label}</Label>
        </motion.div>
        <h1 className="font-heading font-bold uppercase text-navy tracking-tighter leading-[0.92] mt-5 text-5xl md:text-7xl">
          <MaskedLines lines={titleLines} />
        </h1>
        <div className="w-16 h-1 bg-brand mt-8" />
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.6 }}
            className="mt-6 max-w-lg text-lg text-navy/70 leading-relaxed"
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}
